import React from 'react';
import PropTypes from 'prop-types';

import {EVENT_SPORTRADAR_TYPE} from '@constants/variables';
import ArgosJobEditForm from '@modules/events/forms/ArgosJob/ArgosJobEditForm';
import ArgosJobEditModel from '@modules/events/forms/ArgosJob/ArgosJobEditModel';
import {ArgosJobRouteGuard} from '@modules/events/components/ArgosJobRouteGuard';
import {createForm} from '@utils/forms';
import {convertToInt} from '@utils/helpers';

const ArgosJobEditFormContent = ({eventId, argosJobId, eventData, onSaveSuccess}) => {
    const EditForm = createForm(
        ArgosJobEditModel,
        ArgosJobEditForm,
        {
            id: argosJobId,
            optionsVariables: {eventId: convertToInt(eventId)},
            eventStartDatetime: eventData?.start_datetime,
            eventEndDatetime: eventData?.end_datetime,
            isSportradarType: (convertToInt(eventData?.event_type?.id) === EVENT_SPORTRADAR_TYPE),
            onSaveSuccess,
        }
    );

    return <EditForm/>;
};

ArgosJobEditFormContent.propTypes = {
    eventId: PropTypes.string,
    argosJobId: PropTypes.string,
    eventData: PropTypes.object,
    onSaveSuccess: PropTypes.func,
};

export const ArgosJobEditFormWrapper = ({eventId, argosJobId, eventData, jobs, onSaveSuccess}) => (
    <ArgosJobRouteGuard eventId={eventId} argosJobId={argosJobId} jobs={jobs}>
        <ArgosJobEditFormContent
            eventId={eventId}
            argosJobId={argosJobId}
            eventData={eventData}
            onSaveSuccess={onSaveSuccess}
        />
    </ArgosJobRouteGuard>
);

ArgosJobEditFormWrapper.propTypes = {
    eventId: PropTypes.string,
    argosJobId: PropTypes.string,
    eventData: PropTypes.object,
    jobs: PropTypes.array,
    onSaveSuccess: PropTypes.func,
};

